// Angular imports
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Import modules
import { PipesModule } from '../pipes/pipes.module';
import { ComponentsModule } from '../components/components.module';
import { ModalModule } from '../modal/modal.module';

// Import components
import { AddStabuRowModalComponent } from './add-stabu-row-modal/add-stabu-row-modal.component';
import { AddLibraryItemModalComponent } from './add-library-item-modal/add-library-item-modal.component';
import { ImportLinesModalComponent } from './import-lines-modal/import-lines-modal.component';
import { EditHourlyRateModalComponent } from './edit-hourly-wage-modal/edit-hourly-rate-modal.component';
import { LineCommentModalComponent } from './line-comment-modal/line-comment-modal.component';
import { ChangelogModalComponent } from './changelog-modal/changelog-modal.component';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
    declarations: [
        AddStabuRowModalComponent,
        AddLibraryItemModalComponent,
        ImportLinesModalComponent,
        EditHourlyRateModalComponent,
        LineCommentModalComponent,
        ChangelogModalComponent
    ],
    imports: [
        CommonModule,
        PipesModule,
        ComponentsModule,
        ModalModule,
        FormsModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        MatIconModule,
        MatDividerModule,
        MatButtonModule
    ],
    exports: [
        AddStabuRowModalComponent,
        AddLibraryItemModalComponent,
        ImportLinesModalComponent,
        EditHourlyRateModalComponent,
        LineCommentModalComponent,
        ChangelogModalComponent,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        MatIconModule,
        MatDividerModule,
        MatButtonModule
    ]
})
export class ModalsModule { }
